import ApplyParagraphAnnotations from "@elements/ArticleParagraph/ApplyParagraphAnnotations";
import List, { ListElements } from "@elements/List/List";
import { ListItem } from "@elements/List/ListItem/ListItem";
import { ProcessedTextElement } from "@typings/Opensearch";
import { twMerge } from "tailwind-merge";

type ParagraphListProps = {
  listType: ListElements;
  listItems: ProcessedTextElement[];
  listStyle?: string;
  newDesign?: boolean;
};

export default function ParagraphList({
  listStyle,
  listType,
  listItems,
  newDesign,
}: ParagraphListProps) {
  return (
    <List
      style={twMerge(
        newDesign
          ? "font-primary font-semimedium text-black-800 text-[16px] leading-[150%] list-inside ps-[10px] mb-6 lg:mb-8"
          : "font-primaryLight text-black-200 text-2md mb-4 font-extrabold list-inside ps-2md",
        listStyle,
      )}
      Element={listType}
    >
      {listItems.map((item, idx) => (
        <ListItem testId={`item-${idx}`} key={idx}>
          <>{ApplyParagraphAnnotations(item.value, item.annotations)}</>
        </ListItem>
      ))}
    </List>
  );
}

export function ParagraphListMobile({
  listType,
  listItems,
}: ParagraphListProps) {
  return (
    <List Element={listType}>
      {listItems.map((item, idx) => (
        <ListItem testId={`item-${idx}`} key={idx}>
          <>{ApplyParagraphAnnotations(item.value, item.annotations)}</>
        </ListItem>
      ))}
    </List>
  );
}
